import { BaseFieldWidget, ModelFieldType, SPI, TableBooleanFieldWidget, ViewType, TableBooleanSwitchFieldWidget } from '@kunlun/dependencies';

@SPI.ClassFactory(BaseFieldWidget.Token({ viewType: ViewType.Table, ttype: ModelFieldType.Boolean, widget: ['TableSwitch', 'Switch'], multi: false }))
export class CustomTableBooleanSwitchFieldWidget extends TableBooleanFieldWidget {}
